// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"87fc606d","432":"fe77824e","453":"ddc9860c","459":"3dc5a95f","466":"359df6ae","658":"0e9917c6","710":"f471f7ab","895":"3f57651d","913":"09ab10d6","928":"11c34470"}[chunkId] + ".chunk.js";
};